import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = () => ({
  loader: {
    position: "absolute",
    left: "0",
    right: "0",
    top: "0",
    bottom: "0",
    margin: "auto",
  },
});

const FullScreenLoader = (props) => {
  const { classes } = props;

  return (
    <div id="fullscreen-loader">
      <CircularProgress className={classes.loader} />
    </div>
  );
};

FullScreenLoader.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FullScreenLoader);



// WEBPACK FOOTER //
// ./src/components/FullScreenLoader.js